import { render, staticRenderFns } from "./SupplierInvitationEditCard.vue?vue&type=template&id=6b64190e&scoped=true&"
import script from "./SupplierInvitationEditCard.vue?vue&type=script&lang=js&"
export * from "./SupplierInvitationEditCard.vue?vue&type=script&lang=js&"
import style0 from "./SupplierInvitationEditCard.vue?vue&type=style&index=0&id=6b64190e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64190e",
  null
  
)

/* custom blocks */
import block0 from "./SupplierInvitationEditCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardText,VCheckbox,VForm,VSelect})
